import { environment } from 'src/environments/environment';
import {
  API_ERROR_MESSAGES,
  HttpResponseMessages,
  HttpStatus,
  StorageDataText,
} from './model/http';

export class AppConst {
  public static readonly API_BASE_URL: string = environment.api_base_url;

  /**  Data encryption secret key */
  public static readonly ENC_KEY: string = 'manchesterUnited@SirAlexFerguson@26Years';

  /** Enviromental variable */
  public static readonly ENV_VARIABLE: string = 'development';
  //public static readonly ENV_VARIABLE: string = 'prod';

  /**  server HTTP header status code */
  public static readonly HTTP_STATUS: HttpStatus = {
    ERROR: 0,
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UN_AUTHORIZED: 401,
    NOT_FOUND: 404,
    SERVER_INTERNAL_ERROR: 500,
    NO_RECORD: 204,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE_ERROR: 503,
  };

  /* API ERROR CODES */
  public static readonly API_ERROR_MESSAGES: API_ERROR_MESSAGES[] = [
    {
      name: 'CLIENT_ERROR',
      value: [
        {
          error_code: 'ERR00000001',
          description: 'Mandatory Fields not found.',
        },
        {
          error_code: 'ERR00000002',
          description: 'Session already exists.',
        },
        {
          error_code: 'ERR00000003',
          description: 'Password given wrongly.',
        },
        {
          error_code: 'ERR00000004',
          description: 'User account is deActivated.',
        },
        {
          error_code: 'ERR00000021',
          description:
            'User Session has been terminated / invalid access attempted. Please re-login.',
        },
        {
          error_code: 'ERR00000031',
          description: 'Sub org not found.',
        },
        {
          error_code: 'ERR00000032',
          description: 'Master org table empty.',
        },
        {
          error_code: 'ERR00000033',
          description: 'Zero sub organization under a master org.',
        },
        {
          error_code: 'ERR00000034',
          description: 'Duplicate master org name.',
        },
        {
          error_code: 'ERR00000035',
          description: 'Duplicate master org code.',
        },
        {
          error_code: 'ERR00000036',
          description: 'Duplicate sub org name.',
        },
        {
          error_code: 'ERR00000037',
          description: 'Duplicate sub org code.',
        },
        {
          error_code: 'ERR00000040',
          description: 'Error resolving thymeleaf template.',
        },
        {
          error_code: 'ERR00000041',
          description: 'Mail server connection failed.',
        },
        {
          error_code: 'ERR00000042',
          description: 'SMS Gateway client connection failed.',
        },
        {
          error_code: 'ERR00000043',
          description: 'Error creating new EMD Organization.',
        },
        {
          error_code: 'ERR00000044',
          description: 'Error linking EMD Organization to store.',
        },
        {
          error_code: 'ERR00000045',
          description: 'Error linking EMD Organization to suborganizations.',
        },
        {
          error_code: 'ERR00000046',
          description: 'Error creating new EMD Category.',
        },
        {
          error_code: 'ERR00000047',
          description: 'Error linking EMD Organization to EMD Category.',
        },
        {
          error_code: 'ERR00000048',
          description: 'Error linking EMD Category to subcategories.',
        },
        {
          error_code: 'ERR00000049',
          description: 'Error creating new EMD Rule.',
        },
        {
          error_code: 'ERR00000050',
          description: 'Duplicate  EMD Organization name found.',
        },
        {
          error_code: 'ERR00000051',
          description: 'Duplicate  EMD Categoryname found.',
        },
        /*  */
        {
          error_code: 'ERR00000048',
          description: 'Error linking EMD Category to subcategories.',
        },
        {
          error_code: 'ERR00000052',
          description: 'File extension is not allowed.',
        },
        {
          error_code: 'ERR00000053',
          description:
            'You are uploading a file which is not under allowed size.',
        },
        {
          error_code: 'ERR00000054',
          description: 'Please select atleast one attribute to proceed.',
        },
        {
          error_code: 'ERR0000044444',
          description: 'Session invalidated. Please log in again.',
        },
      ],
    },
    {
      name: 'BUSINESS_ERROR',
      value: [
        {
          error_code: 'ERR00000018',
          description: 'Record not found.',
        },
        {
          error_code: 'ERR00000019',
          description: 'Sql related issues, Please check the query properly.',
        },
        {
          error_code: 'ERR00000027',
          description: 'Duplicate Category Group Found!.',
        },
        {
          error_code: 'ERR00000028',
          description: 'Duplicate Category Found!.',
        },
        {
          error_code: 'ERR00000029',
          description: 'Dupliacte Sub-category Found!.',
        },
      ],
    },

    {
      name: 'MJ_ERROR',
      value: [
        {
          error_code: 'ERR00000055',
          description: 'Error in retrieving  Debar Data.',
        },
        {
          error_code: 'ERR00000056',
          description: 'Unable To Fetch Debar Status.',
        },
        {
          error_code: 'ERR00000057',
          description: 'Unable to Approve/Reject Debar/Undebar Request.',
        },
        {
          error_code: 'ERR00000058',
          description: 'Unable fetch Average TAT.',
        },
        {
          error_code: 'ERR00000059',
          description: 'Unable fetch Debar Rejection Reason.',
        },
        {
          error_code: 'ERR00000060',
          description: 'For Regenerate , please send the userId.',
        },
        {
          error_code: 'ERR00000061',
          description: 'Mail and phone number already exists for this userId .',
        },
      ],
    },
  ];

  /* API ERROR CODES */

  public static readonly API_MESSAGES: HttpResponseMessages = {
    200: 'Data returned successfully',
    201: 'Data created successfully',
    204: 'No Record found',
    404: 'Page Not Found',
    401: 'Unauthorised Service',
    500: 'Sorry! Server encountered an error.Please try again later',
    503: 'Service Unavailable',
  };

  /** application's storage data key name */
  public static readonly STORAGE_DATA_FOR: StorageDataText = {
    USER_DATA: 'userAdminData',
  };

  public static readonly SALT_VALUE: string = 'ertyfghjkyuiojklpldjxmjedh';
  public static readonly KEY_BASE_64: string =
    'o9szYIOq1rRMiouNhNvaq96lqUvCekxR';

  public static readonly DATA_TABLE_PAGE_LENGTH = [
    10, 20, 50, 100, 200, 300, 400, 500, 2000
  ];

  public static readonly REQUEST_TYPE = [
    { value: '', name: 'Please Select A Request Type' },
    { value: 'ALL', name: 'ALL' },
    { value: 'DEBAR REQUEST', name: 'DEBAR REQUEST' },
    { value: 'UNDEBAR REQUEST', name: 'UNDEBAR REQUEST' },
  ];

  public static readonly REQUEST_STATUS = [
    { value: '', name: 'Please Select A Request Status' },
    { value: 'PENDING', name: 'PENDING' },
    { value: 'APPROVED', name: 'APPROVED' },
    { value: 'REJECTED', name: 'REJECTED' },
  ];

  public static readonly DEFAULT_TIMEOUT = 120000;

  public static readonly DEFAULT_PAGENUMBER = 1;

  public static readonly DEFAULT_POST_FIX_USERNAME = '';

  public static readonly DEFAULT_AWS_METAL_BUCKET_CREDENTIALS = {
    bucket: 'aws-metal-dev',
    catalogBucket: 'catalogue-docs',
    catalogUrl: 'https://auctionv2-docs.metaljunction.com/',
    region: 'ap-south-1',
    accessKeyId: 'AKIA57EKRFUABLBQR3OY',
    secretKeyId: 'HxsPKNkWSEt4v3jbeIG6GWnksMV0TjZMV5EgAjJa',
    pdfPath: 'CatalogPdfs',
    expiresIn: 3600,
  };

  public static readonly PDF_VIEW_LOCAL = false;
  public static readonly DEFAULT_CREDENTIALS_SERVER_DOCBUCKET = {
    bucket: 'serverdocmetaljunction',
    catalogBucket: 'UserScannedDcoument',
    catalogUrl: '',
    region: 'ap-south-1',
    accessKeyId: 'AKIA57EKRFUABLBQR3OY',
    secretKeyId: 'HxsPKNkWSEt4v3jbeIG6GWnksMV0TjZMV5EgAjJa',
    pdfPath: 'UserScannedDcoument/',
    expiresIn: 3600,
  };

  /* For Future Use Of Other Bucket */
  /*   public static readonly DEFAULT_AWS_BUCKET_ACCESS_KEY_ID = {
    awsaccessKeyIdImage: 'AKIAXG2UWSRULK5XVUS7',
    awsaccessKeyIdPdf: 'AKIA57EKRFUAB6DI3IEH',
  };

  public static readonly DEFAULT_AWS_BUCKET_SECRET_KEY_ID = {
    awssecretAccessKeyImage: 'vu0tVEzBVyAJ7E+JW3Gr/a/WpVRBJLnY4Ad17yfB',
    awssecretAccessKeyPdf: '4B67CJ1U81/QNaiizGm0JwMlmfjXNGUNUA1FbET8',
  }; */

  public static readonly FILE_TYPE = {
    jpg: 'image/jpeg',
    png: 'image/png',
    jpeg: 'image/jpeg',
    video: 'video/mp4',
    pdf: 'application/pdf',
    excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  };

  public static readonly MIME_TYPE = {
    jpg: 'image/jpeg',
    png: 'image/png',
    jpeg: 'image/jpeg',
    video: 'video/mp4',
    pdf: 'application/pdf',
    excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  };

  public static readonly FILE_SIZE = {
    jpg: '5242880', // bytes 5MB
    png: '5242880', // bytes 5MB
    jpeg: '5242880', // bytes 5MB
    video: '20971520', // bytes 20MB
    pdf: '10485760', // bytes 10MB
    excel: '10485760', // bytes 10MB
    trainingVideo: '52428800', // bytes 50MB
  };

  public static readonly EXTERNAL_JS = {
    bpnmJS: 'https://unpkg.com/bpmn-js/dist/bpmn-viewer.development.js',
    sockJs: 'assets/js/sockjs.min.js',
    adobeJs: 'https://acrobatservices.adobe.com/view-sdk/viewer.js',
  };

  public static readonly EXTERNAL_CSS = {
    materialIcon: 'https://fonts.googleapis.com/css?family=Material+Icons',
    googleAPIFont: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500',
  };

  public static readonly OTP_TIMER = 300; // seconds

  public static readonly LIVE_AUCTION_REFRESH = 60000;

  /* Rakuten */
  // public static readonly RAKUTEN_AUTH = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZWFtSWQiOiJhYzA1OWVmYS1lOGE3LTQxNDAtOGM5MS03MmQ1NmJiODIwZGUiLCJiaWxsaW5nX2lkIjoiMmYwOWQyNWEtMjAyZS00ODg2LWFjOGYtN2JiZjFmMzI3NDJkIiwiaWF0IjoxNzIxMjc4MDA0LCJhdWQiOiJvYXAiLCJpc3MiOiJzaXh0aC1zZW5zLWF1dGgifQ.dKfdpdpbIxKljvMQflT2OR8MfKctn2HDBvpD89iPWJA";
  
  // public static readonly RAKUTEN_SERVICE_NAME = 'RACE METAL ADMIN UAT'
  
  // public static readonly RAKUTEN_COLLECTOR = "https://http-collector-observability.sixthsense.rakuten.com/oap"

  // public static readonly RAKUTEN_SERVICE_VERSION = "1.0.0"


  // public static RAKUTEN_AUTH: string
  
  // public static RAKUTEN_SERVICE_NAME: string;
  
  // public static RAKUTEN_COLLECTOR: string;

  // public static RAKUTEN_SERVICE_VERSION: string;

}

// For Store Metal & MJPLUS (100, 122) 
export class RakutenData {

  public readonly RAKUTEN_AUTH: string;

  public readonly RAKUTEN_SERVICE_NAME: string;

  public readonly RAKUTEN_COLLECTOR: string;

  public readonly RAKUTEN_SERVICE_VERSION: string; 

  constructor(

    RAKUTEN_AUTH: string,
    RAKUTEN_SERVICE_NAME: string,
    RAKUTEN_COLLECTOR: string,
    RAKUTEN_SERVICE_VERSION: string,

  ) {

    this.RAKUTEN_AUTH = RAKUTEN_AUTH;
    this.RAKUTEN_SERVICE_NAME = RAKUTEN_SERVICE_NAME;
    this.RAKUTEN_COLLECTOR = RAKUTEN_COLLECTOR;
    this.RAKUTEN_SERVICE_VERSION = RAKUTEN_SERVICE_VERSION;
    Object.freeze(this);

  }

}

// For Store Agro & Fci (113, 103) 
export class AgroData {

  // FOR AGRO DEV & AGRO PROD | FCI DEV & FCI PROD

  public readonly RECAPTCHA_V2_KEY: string;

  public readonly RECAPTCHA_V3_KEY: string;

  public readonly metalAnalyticsBaseUrl: string;

  public readonly rakAnalyticsBaseUrl: string;
  
  constructor(

    RECAPTCHA_V2_KEY: string,
    RECAPTCHA_V3_KEY: string,
    metalAnalyticsBaseUrl: string,
    rakAnalyticsBaseUrl: string,

  ) {

    this.RECAPTCHA_V2_KEY = RECAPTCHA_V2_KEY;
    this.RECAPTCHA_V3_KEY = RECAPTCHA_V3_KEY;
    this.metalAnalyticsBaseUrl = metalAnalyticsBaseUrl;
    this.rakAnalyticsBaseUrl = rakAnalyticsBaseUrl;
    Object.freeze(this);

  }

}

export class CommonStoreData {

  public readonly pythonApi: string;

  constructor(

    pythonApi: string

  ) {

    this.pythonApi = pythonApi;
    Object.freeze(this);

  }

}

 